import React, { useState } from 'react';
import Problema from '../../../../assets/images/mimo2.png';
import Sinal from '../../../../assets/images/mimo.png';
import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';

function Tecnologias() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Tecnologias - MIMO, MU-MIMO e OFDMA</h1>
            <img src={Problema} alt='problema' className='mb-0' />
            <Card className="text-center">
              <Card.Header><div className="opcoes">Tecnologias disponíveis</div></Card.Header>
              <Card.Body>
                {/* <Card.Title>Coleta de Informações e Análise do Ambiente</Card.Title> */}
                <Card.Text>
                  <div className='opcoes'>
                    <div>
                      <strong>1. MIMO: </strong>
                      Permite a transmissão e recepção simultânea de dados,
                      aumentando a eficiência da rede.
                    </div>
                    <br />
                    <div>
                      <strong>2. MU-MIMO: </strong>
                      Atende simultaneamente a múltiplos dispositivos, melhorando a capacidade e a experiência do usuário.
                    </div>
                    <br />
                    <div>
                      <strong>3. OFDMA: </strong>
                      OFDMA (Orthogonal Frequency Division Multiple Access), que divide os canais de Wi-Fi em subcanais menores, 
                      permitindo que vários dispositivos compartilhem o mesmo canal.
                    </div>
                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted">

              </Card.Footer>
            </Card>

          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Sinal} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Tecnologias;
